import React from 'react';
import {compose} from 'react-apollo';

import {Button, Card} from 'ui-kit';

import * as styles from './PaymentDetailsCard.module.css';

function PaymentDetailsCard({cardLast4, openPaymentModal}) {
  return (
    <Card>
      <h3 className={styles.Heading}>Payment details</h3>
      <div className={styles.ContentContainer}>
        {cardLast4 == null || cardLast4 === '' ? (
          <p>
            <small>No card on file</small>
          </p>
        ) : (
          <>
            <p>
              <strong>
                <small>Card on file</small>
              </strong>
            </p>
            <p>
              <small>Ending in {cardLast4}</small>
            </p>
          </>
        )}
        <div className={styles.EditButtonContainer}>
          <Button color="light" size="small" onClick={openPaymentModal}>
            Edit
          </Button>
        </div>
      </div>
    </Card>
  );
}

export default compose()(PaymentDetailsCard);
